<template>
    <div
        v-if="isActivatedOnboardingEmailV2 && !isAuthDomain"
        class="email-listing-domain-auth-banner"
    >
        <div class="alert alert-warning">
            <p class="flex-level jc-space">
                <span>
                    {{
                        $l10n.__(
                            'Attention votre domaine n’est pas encore authentifié. La délivrabilité de vos emails peut en être affectée.',
                        )
                    }}
                    <span class="link" @click="checkDomainAuth()">
                        {{ $l10n.__('Vérifier l’authentification de mon domaine') }}</span
                    >
                </span>
                <a
                    class="link"
                    href="https://help.sellsy.com/hc/receiving-and-sending-emails-with-sellsy/set-up-your-domain-for-better-deliverability?searched=true"
                    target="_blank"
                >
                    {{ $l10n.__('Besoin d’aide ? Accéder à notre tutoriel') }}</a
                >
            </p>
        </div>

        <!-- POPUP -->
        <CompassModal
            v-model:visible="infoModal.active"
            class="email-listing-domain-auth-dialog__failed"
            size="small"
            :title="infoModal.title"
            @before-close="beforeClose(infoModal.isAuth)"
        >
            <template #default>
                <div class="dialog__default acenter">
                    <i class="modal-icon" :class="infoModal.icon"></i>
                    <p class="typographies-paragraph-medium-regular">
                        {{ infoModal.description }}
                    </p>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="infoModal.primaryBtn.label"
                        type="primary"
                        @click="beforeClose(infoModal.isAuth)(infoModal.primaryBtn.action)"
                    />
                </div>
            </template>
        </CompassModal>
    </div>
</template>

<script>
import OnboardingEmailApi from 'api/onboarding/email/onboardingEmail.js';
import LocalStorage from 'Core/commons/LocalStorage';

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
const namespace = 'emailListing';

export default {
    name: 'EmailListingDomainAuthBanner',
    data() {
        return {
            isActivatedOnboardingEmailV2: false,
            isAuthDomainStorage: null,
            isAuthDomain: false,
            infoModal: {
                active: false,
                primaryBtn: {
                    action: () => (this.infoModal.active = false),
                    label: this.$l10n.__('Fermer cette fenêtre'),
                },
            },
        };
    },
    computed: {
        ...mapStateUser(['email']),
        domain() {
            if (this.email) {
                return this.email.split('@').pop();
            }
            return '';
        },
    },
    /**
     * Find isAuthDomain in localStorage and if exist set auth domain according to
     */
    created() {
        this.isAuthDomainStorage = new LocalStorage(namespace, 'isAuthDomain');
        this.isActivatedOnboardingEmailV2 = new LocalStorage('onboardingEmail', 'V2').get();

        if (this.isActivatedOnboardingEmailV2) {
            this.isAuthDomainStorage.get() ? this.setAuthDomain(true) : this.setAuthDomain(false);
        }
    },
    methods: {
        /**
         * Call api to know if domain is validated
         */
        checkDomainAuth() {
            OnboardingEmailApi.authDomainValidation({ domain: this.domain }).then(() => {
                OnboardingEmailApi.validateDomainAuth(this.email).then(
                    (isAuth) =>
                        isAuth ? this.isValidateDomain(isAuth) : this.isNotValidateDomain(isAuth),
                    (err) => console.error(`OnboardingEmailApi::validateDomainAuth`, err),
                );
            });
        },
        /**
         * If the domain is validated, display modal with success message
         */
        isValidateDomain(isAuth) {
            this.infoModal = {
                ...this.infoModal,
                isAuth,
                active: true,
                icon: 'icon-email-statut-valid green',
                title: this.$l10n.__('Votre domaine est désormais authentifié'),
                description: this.$l10n.__(
                    'L’authentification de votre domaine vous permet désormais une délivrabilité optimale de vos futurs emails.',
                ),
            };
        },
        /**
         * If the domain is not validated, display modal with error message
         */
        isNotValidateDomain(isAuth) {
            this.infoModal = {
                ...this.infoModal,
                isAuth,
                active: true,
                icon: 'icon-email-statut-valid red',
                title: this.$l10n.__('Votre domaine n’est pas authentifié'),
                description: this.$l10n.__(
                    'L’authentification de votre domaine a échoué. Merci de réessayer ultérieurement.',
                ),
            };
        },
        /**
         * Callback before Dialog closes :
         *  - Store in localStorage if domain is authenticated so as display or not banner the next time
         *  - Use done() to close the Dialog
         */
        beforeClose(isAuth) {
            return (done) => {
                this.setAuthDomain(isAuth);
                done();
            };
        },
        /**
         * Store in localStorage if domain is authenticated so as display or not banner the next time
         * And update isAuthDomain localy
         */
        setAuthDomain(isAuth) {
            this.isAuthDomainStorage.set(isAuth);
            this.isAuthDomain = this.isAuthDomainStorage.get();
        },
    },
};
</script>

<style lang="scss" scoped>
.email-listing-domain-auth-dialog__failed {
    .dialog {
        &__default {
            p {
                margin: 0;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-5) var(--spacing-4);
        }
    }
}
.modal-icon {
    font-size: 72px;
}
</style>
